export default __webpack_public_path__ + "1e601315485f54d44a03b9d843856188.svg";